(function () {
	'use strict';

	angular.module('qbePortal').controller('QBCycleCoverSummaryController', QBCycleCoverSummaryController);
	QBCycleCoverSummaryController.$inject = ['$scope'];


	function QBCycleCoverSummaryController($scope) {
		var vm = this;
		var tableValues = {
			cycleCover: $scope.cycleCover,
			generalEquipment: $scope.generalEquipment,
			specifiedEquipment: $scope.specifiedEquipment,
			includeCycleRacing: $scope.includeCycleRacing
		};

	}

	angular.module('qbePortal').component('qbCycleCoverSummary', {
		templateUrl: '../ngviews/components/qbCycleCoverSummary.html',
		controller: QBCycleCoverSummaryController,
		controllerAs: 'vm',
		bindings: {
			cycleCover: '=',
			generalEquipment: '=',
			specifiedEquipment: '=',
			includeCycleRacing: '='
		}
	});
})();
